import { InfoCircle, XClose } from '@untitled-ui/icons-react/build/cjs';
import React, { useState } from 'react';

interface IProps {
    style?: 'info' | 'error';
    label?: string;
    labelInfo?: any;
    CloseAlert?: boolean;
    className?: string;
}

const AlertMessage = ({ style = 'info', labelInfo, label, CloseAlert, className }: IProps) => {
    const [visible, setVisible] = useState(true);

    if (!visible) return null;

    return (
        <div
            className={`px-3 py-2.5 rounded-md border  flex gap-x-2 ${
                style === 'error' ? 'border-utilityError300 bg-utilityError50' : style === 'info' ? 'border-borderSecondary bg-utilityIndigo25' : ''
            } ${className}`}
        >
            <InfoCircle className={`mt-px w-3.5 h-3.5 ${style === 'error' ? 'text-utilityError400' : style === 'info' ? 'text-primary' : 'text-textSecondary'}`} />
            <p className={`text-textSecondary text-xs font-medium flex-1`}>
                {label && <span className="text-grayLight900 font-semibold">{label}&nbsp;</span>}
                {labelInfo}
            </p>
            {CloseAlert && (
                <>
                    <div
                        className={`cursor-pointer [&>svg]:w-3 [&>svg]:text-grayLight600 bg-transparent hover:bg-[#e5e5e5] transition-all duration-300 h-[16px] w-[16px] flex justify-center items-center rounded-full flex-none `}
                        onClick={() => setVisible(false)}
                    >
                        <XClose className="text-gray500 hover:text-textSecondary" />
                    </div>
                </>
            )}
        </div>
    );
};

export default AlertMessage;
